export default __webpack_public_path__ + "static/media/GoogleLogo.483f4dad.svg";